import { toast } from "react-hot-toast";

export const handleError = (error:any) => {
      console.log(error)

  if (error.response) {
    // Server responded but with an error
    switch (error.response.status) {
      case 400:
        toast.error("Bad request. Please check your input.");
        break;
      case 401:
        toast.error("Unauthorized. Please log in again.",   { 
            duration: 4000,
            position: "bottom-right",
            style: {
            background: "red",
            color: "#fff"}});
//redirect to login page
            window.location.href = "/login";
        break;
      case 403:
        toast.error("You do not have permission to access this resource.");
        window.location.href = "/login";
        break;
      case 404:
        toast.error("Resource not found.");
        break;
      case 500:
        toast.error("Server error. Please try again later.");
        break;
      default: break
        // toast.error(`Unexpected error: ${error.response.status}`);
        // toast.error(`Unexpected error: ${error.response.message}`);
    }
  } else if (error.request) {
    // No response received
    // toast.error("Connexion impossible, réessayer plus tard",
    //     { 
    //         duration: 4000,
    //         position: "bottom-right",
    //         style: {
    //         background: "red",
    //         color: "#fff"}}); 

              // 👇 Redirect to a dedicated network error page
  window.location.href = "/network-error";

  } else {
    // Something else happened
    toast.error("An unexpected error occurred.");
  }
};
